import * as React from "react";
import { computed } from "mobx";
import { observer, inject } from "mobx-react";
import * as UiStore from "../States/AreaUiInfo";

export interface IAreaBodyProps extends UiStore.IAreaUiInfo {
	id?: string;
	loading?: boolean;
	noToolbar?: boolean;
}

@inject((allStores : any) => ({
	areaUiInfo: allStores.areaUiInfo as UiStore.AreaUiInfoImpl
}))
@observer
export class AreaBody extends React.Component<IAreaBodyProps, {}> {

	@computed get areaBodyStyle(): React.CSSProperties {
		let left = 0;
		if (this.props.areaUiInfo) {
			left = this.props.areaUiInfo.isCollapsed ? UiStore.asideCollapsedWidth : this.props.areaUiInfo.asideWidth;
		}
		return { left: left };
	}

	@computed get areaBodyClass() {
		let bodyClass = "area-grid__body";
		//We need to set the special class 'is--overlay-fix' to fix the overlay behaviour of the WizardBox for the Move Dialog.
		if (this.props.areaUiInfo && !this.props.areaUiInfo.isCollapsed) {
			bodyClass = bodyClass + " is--overlay-fix";
		}
		if (this.props.noToolbar !== undefined && this.props.noToolbar) {
			bodyClass = bodyClass + " no--toolbar";
		}
		return bodyClass;
	}

	render() {
		return <div id={this.props.id} className={this.areaBodyClass} style={this.areaBodyStyle} >
			{this.props.loading ? <div className="spinner">
				<div className="spinner-inner">

					<i>
						<svg className="spinner-animation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
							<path className="spinner-custom" d="M24,5A19,19,0,0,1,43,24h3A22,22,0,0,0,24,2Z" />
							<path d="M24,43A19,19,0,0,1,24,5V2A22,22,0,1,0,46,24H43A19,19,0,0,1,24,43Z" />
						</svg>
					</i>

				</div>
				<div className="spinner-label">Loading</div>
			</div> : this.props.children}
		</div>
	}
}
